import HeroBg from "public/cyber-security/edrmdrxdr/heroBg.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Secure Your Business Now",
    link: "contact-us",
  },
  desc: "Modern threats need modern defences. OneMind offers AI-powered EDR, MDR, and XDR solutions for smarter protection.",
  title: "EDR | MDR | XDR – \n The Future of Cybersecurity",
  image: HeroBg,
};
